import * as React from 'react'
import * as moment from 'moment'
import { IActiveTripResponseV2, ITripStatus, IStateUser } from '../../../types'
import { TripStatuses } from '../../../constants/trip-statuses'
import ToolTip from '../../ui/ToolTip'
import { Route, Link, RouteComponentProps } from 'react-router-dom'
import PickupNote from './note-modal/PickupNote'
import DropOffNote from './note-modal/DropOffNote'
import DriverPnoteModal from '../../../containers/trips/DriverPnoteModal'
import DriverDnoteModal from '../../../containers/trips/DriveDnoteModal'
import PreloaderCircle from 'src/components/ui/PreloaderCircle'
interface ITripActivityLogProps extends RouteComponentProps<any> {
  currentTrip: IActiveTripResponseV2
  timeFormat: string
  trips: IActiveTripResponseV2
  getManyStatusesById: (tripId: string) => Promise<ITripStatus[]>
  fetchUserById: (userId: string) => Promise<IStateUser>
}

interface ITripActivityLog {
  requestor: string
  requestedAt: string
  driverAcceptedAt: string
  driverStartedAt: string
  driverArrivedAt: string
  pickedupAt: string
  driverLeftAt: string
  droppedoffAt: string
  completedAt: string
  canceledBy: string
  canceledAt: string
  manuallyCompletedBy: string
  manuallyCompletedAt: string
  driverCancelled: string
}

interface ITripActivityLogState {
  tripActivity: ITripActivityLog
  isSchedule: boolean
  isLoading: boolean
}

class TripActivityLog extends React.Component<ITripActivityLogProps, ITripActivityLogState> {
  public state = {
    tripActivity: {} as ITripActivityLog,
    isSchedule: false,
    isLoading: true
  }

  public async componentDidMount() {
    const statuses = await this.props.getManyStatusesById(this.props.currentTrip.id)
    const tripActivity: any = {}
    for (const s of statuses) {
      if (
        s.status === TripStatuses.WAITING ||
        s.status === TripStatuses.REQUESTED ||
        s.status === TripStatuses.SCHEDULED ||
        s.status === TripStatuses.SCHEDULE_REQUESTED
      ) {
        if (s.createdBy) {
          if (s.createdBy === 'system') {
            tripActivity.requestor = 'System Generated'
          } else {
            const user = await this.props.fetchUserById(s.createdBy)
            tripActivity.requestor = user.firstName + ' ' + user.lastName
          }
        }
        tripActivity.requestedAt = s.createdAt
        this.setState({
          isSchedule: s.status === TripStatuses.SCHEDULED
        })
      } else if (
        s.status === TripStatuses.CANCELLED ||
        s.status === TripStatuses.CANCEL_BILLABLE ||
        s.status === TripStatuses.RIDER_CANCELLED
      ) {
        const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi
        if (s.createdBy && regexExp.test(s.createdBy)) {
          const user = await this.props.fetchUserById(s.createdBy)
          tripActivity.canceledBy = user.firstName + ' ' + user.lastName
        } else {
          tripActivity.canceledBy = s.createdBy
        }
        tripActivity.canceledAt = s.createdAt
      }
      //Added Driver Cancelled
      else if (s.status === TripStatuses.DRIVER_CANCELLED) {
        tripActivity.driverCancelled = s.createdAt
      }
      //Added Driver Cancelled
      else if (s.status === TripStatuses.ACCEPTED) {
        tripActivity.driverAcceptedAt = s.createdAt
      } else if (s.status === TripStatuses.TO_PICK_UP) {
        tripActivity.driverStartedAt = s.createdAt
      } else if (s.status === TripStatuses.AT_PICK_UP) {
        tripActivity.driverArrivedAt = s.createdAt
      } else if (s.status === TripStatuses.PICKED_UP) {
        tripActivity.pickedupAt = s.createdAt
      } else if (s.status === TripStatuses.TO_DROP_OFF) {
        tripActivity.driverLeftAt = s.createdAt
      } else if (s.status === TripStatuses.AT_DROP_OFF) {
        tripActivity.droppedoffAt = s.createdAt
      } else if (s.status === TripStatuses.COMPLETED) {
        tripActivity.completedAt = s.createdAt
      } else if (s.status === TripStatuses.MANUALLY_COMPLETED) {
        if (s.createdBy) {
          const user = await this.props.fetchUserById(s.createdBy)
          tripActivity.manuallyCompletedBy = user.firstName + ' ' + user.lastName
        }
        tripActivity.manuallyCompletedAt = s.createdAt
      }
    }

    this.setState({
      tripActivity,
      isLoading: false
    })
  }

  public render() {
    const { tripActivity, isSchedule, isLoading } = this.state
    const { currentTrip, trips } = this.props
    const { scheduledPickupTime, scheduledDropoffTime } = currentTrip

    const currentTripStatus = currentTrip.status
      ? currentTrip.status.find(item => item.statusId === currentTrip.lastStatusId)
      : {
          status: currentTrip.lastStatus,
          createdAt: currentTrip.lastStatusAt,
          comment: ''
        }
    const comment = currentTripStatus ? currentTripStatus.comment : null
    const createdAt = currentTripStatus ? currentTripStatus.createdAt : null

    const timeFormat = this.props.timeFormat === 'mil' ? 'MMM DD, HH:mm' : 'MMM DD, h:mm a'
    const PickupNoteModal = (props: any) => {
      return (
        <DriverPnoteModal
          currentTripId={this.props.currentTrip.id}
          startMileage={this.props.currentTrip.startMileage}
          {...props}
        />
      )
    }
    const DropoffNoteModal = (props: any) => {
      return (
        <DriverDnoteModal
          currentTripId={this.props.currentTrip.id}
          endMileage={this.props.currentTrip.endMileage}
          {...props}
        />
      )
    }
    // 3 = pickup note
    // 4 = dropoff note
    // 5 = Assigned a driver
    const getNote = (tripEditHistory: any, note: number) => {
      if (!tripEditHistory) {
        return ''
      }
      const editHistory = tripEditHistory.find((history: any) => history.column === note)
      const r = editHistory ? editHistory.currentData : ''
      return r
    }

    if (isLoading) {
      return (
        <div>
          <PreloaderCircle loading={true} />
        </div>
      )
    }

    return (
      <React.Fragment>
        <section>
          <Route exact={true} path={`${this.props.match.url}/edit-note-pickup`} render={PickupNoteModal} />
          <Route exact={true} path={`${this.props.match.url}/edit-note-dropoff`} render={DropoffNoteModal} />
          <div className='flex mt1'>
            <span className='font-dark-grey h6 weight-500 td-more-details-title'>
              Trip {isSchedule ? 'scheduled' : 'requested'} by {tripActivity.requestor}
            </span>
            <ToolTip message={moment(tripActivity.requestedAt).format('lll')}>
              <span className='font-dark-grey h6 weight-500'>
                {moment(tripActivity.requestedAt).format(timeFormat)}
              </span>
            </ToolTip>
          </div>
          {tripActivity.driverAcceptedAt && (
            <div className='flex mt1'>
              <span className='font-dark-grey h6 weight-500 td-more-details-title'>Driver accepted trip</span>
              <ToolTip message={moment(tripActivity.driverAcceptedAt).format('lll')}>
                <span className='font-dark-grey h6 weight-500'>
                  {moment(tripActivity.driverAcceptedAt).format(timeFormat)}
                </span>
              </ToolTip>
            </div>
          )}
          {tripActivity.driverStartedAt && (
            <div className='flex mt1'>
              <span className='font-dark-grey h6 weight-500 td-more-details-title'>Driver drove to Pickup</span>
              <ToolTip message={moment(tripActivity.driverStartedAt).format('lll')}>
                <span className='font-dark-grey h6 weight-500'>
                  {moment(tripActivity.driverStartedAt).format(timeFormat)}
                </span>
              </ToolTip>
            </div>
          )}
          {scheduledPickupTime && (
            <div className='flex mt1'>
              <span className='font-dark-grey h6 weight-500 td-more-details-title'>Scheduled Pickup</span>
              <ToolTip message={moment(scheduledPickupTime).format('lll')}>
                <span className='font-dark-grey h6 weight-500'>{moment(scheduledPickupTime).format(timeFormat)}</span>
              </ToolTip>
            </div>
          )}
          {tripActivity.driverArrivedAt && (
            <div className='flex mt1'>
              <span className='font-dark-grey h6 weight-500 td-more-details-title'>Driver arrived at Pickup</span>
              <ToolTip message={moment(tripActivity.driverArrivedAt).format('lll')}>
                <span className='font-dark-grey h6 weight-500'>
                  {moment(tripActivity.driverArrivedAt).format(timeFormat)}
                </span>
              </ToolTip>
            </div>
          )}
          {/* Added Pick Up Note */}
          {
            <div className='flex mt1'>
              <span className='font-dark-grey h6 weight-500 td-more-details-title'>Pick-Up Notes</span>
              <ToolTip message={`${getNote(currentTrip.tripEditsHistory, 3)}`}>
                <span className='font-dark-grey h6 weight-500 mr1'>
                  {currentTrip.pickUpFlag === 0 && currentTrip.startMileage}
                  {currentTrip.pickUpFlag !== 0 && getNote(currentTrip.tripEditsHistory, 3) + ' (edited)'}
                </span>
              </ToolTip>
              <PickupNote actionUrl={`${this.props.match.url}/edit-note-pickup`} />
            </div>
          }
          {/* Added Pick Up Note */}
          {tripActivity.pickedupAt && (
            <div className='flex mt1'>
              <span className='font-dark-grey h6 weight-500 td-more-details-title'>Rider picked up</span>
              <ToolTip message={moment(tripActivity.pickedupAt).format('lll')}>
                <span className='font-dark-grey h6 weight-500'>
                  {moment(tripActivity.pickedupAt).format(timeFormat)}
                </span>
              </ToolTip>
            </div>
          )}
          {tripActivity.driverLeftAt && (
            <div className='flex mt1'>
              <span className='font-dark-grey h6 weight-500 td-more-details-title'>Driver left to Dropoff</span>
              <ToolTip message={moment(tripActivity.driverLeftAt).format('lll')}>
                <span className='font-dark-grey h6 weight-500'>
                  {moment(tripActivity.driverLeftAt).format(timeFormat)}
                </span>
              </ToolTip>
            </div>
          )}
          {scheduledDropoffTime && (
            <div className='flex mt1'>
              <span className='font-dark-grey h6 weight-500 td-more-details-title'>Scheduled Dropoff</span>
              <ToolTip message={moment(scheduledDropoffTime).format('lll')}>
                <span className='font-dark-grey h6 weight-500'>{moment(scheduledDropoffTime).format(timeFormat)}</span>
              </ToolTip>
            </div>
          )}
          {tripActivity.droppedoffAt && (
            <div className='flex mt1'>
              <span className='font-dark-grey h6 weight-500 td-more-details-title'>Arrived at Dropoff</span>
              <ToolTip message={moment(tripActivity.droppedoffAt).format('lll')}>
                <span className='font-dark-grey h6 weight-500'>
                  {moment(tripActivity.droppedoffAt).format(timeFormat)}
                </span>
              </ToolTip>
            </div>
          )}
          {/* Added Drop off Note */}
          {
            <div className='flex mt1'>
              <span className='font-dark-grey h6 weight-500 td-more-details-title'>Drop-off Note</span>
              <ToolTip message={`${getNote(currentTrip.tripEditsHistory, 4)}`}>
                <span className='font-dark-grey h6 weight-500 mr1'>
                  {currentTrip.dropOffFlag === 0 && currentTrip.endMileage}
                  {currentTrip.dropOffFlag !== 0 && getNote(currentTrip.tripEditsHistory, 4) + ' (edited)'}
                </span>
              </ToolTip>
              <DropOffNote actionUrl={`${this.props.match.url}/edit-note-dropoff`} />
            </div>
          }
          {/* Added Drop off Note */}
          {tripActivity.completedAt && (
            <div className='flex mt1'>
              <span className='font-dark-grey h6 weight-500 td-more-details-title'>Trip completed</span>
              <ToolTip message={moment(tripActivity.completedAt).format('lll')}>
                <span className='font-dark-grey h6 weight-500'>
                  {moment(tripActivity.completedAt).format(timeFormat)}
                </span>
              </ToolTip>
            </div>
          )}
          {tripActivity.canceledAt && (
            <div className='flex mt1'>
              <span className='font-dark-grey h6 weight-500 td-more-details-title'>
                Trip canceled by {tripActivity.canceledBy}
              </span>
              <ToolTip message={moment(tripActivity.completedAt).format('lll')}>
                <span className='font-dark-grey h6 weight-500'>
                  {moment(tripActivity.canceledAt).format(timeFormat)}
                </span>
              </ToolTip>
            </div>
          )}
          {/*  Added Driver Cancelled */}
          {tripActivity.driverCancelled && (
            <div className='flex mt1'>
              <span className='font-dark-grey h6 weight-500 td-more-details-title'>Driver cancelled trip at</span>
              <ToolTip message={moment(tripActivity.completedAt).format('lll')}>
                <span className='font-dark-grey h6 weight-500'>
                  {moment(tripActivity.driverCancelled).format(timeFormat)}
                </span>
              </ToolTip>
            </div>
          )}
          {/*  Added Driver Cancelled or Cancel_Billable or Rider Cancelled */}
          {comment && (
            <div className='flex mt1'>
              <span className='font-dark-grey h6 weight-500'>
                <b>Reason:</b> {comment}
              </span>
              <ToolTip message={moment(createdAt).format('lll')}>
                <span className='font-dark-grey h6 weight-500'>
                  {moment(tripActivity.canceledAt).format(timeFormat)}
                </span>
              </ToolTip>
            </div>
          )}
          {tripActivity.manuallyCompletedAt && (
            <div className='flex mt1'>
              <span className='font-dark-grey h6 weight-500 td-more-details-title'>
                Trip Manually completed by {tripActivity.manuallyCompletedBy}{' '}
              </span>
              <ToolTip message={moment(tripActivity.manuallyCompletedAt).format('lll')}>
                <span className='font-dark-grey h6 weight-500'>
                  {moment(tripActivity.manuallyCompletedAt).format(timeFormat)}
                </span>
              </ToolTip>
            </div>
          )}
          <div className='flex mt1'>
            <span className='font-dark-grey h6 weight-500 td-more-details-title'>Ride Reconfirmation Count</span>
            <ToolTip message={''}>
              <span className='font-dark-grey h6 weight-500'>
                {currentTrip.rideReconfirmationCount ? currentTrip.rideReconfirmationCount : 0}
              </span>
            </ToolTip>
          </div>
          {currentTrip.tripCode && (
            <div className='flex mt1'>
              <span className='font-dark-grey h6 weight-500 td-more-details-title'>Trip Code</span>
              <ToolTip message={''}>
                <span className='font-dark-grey h6 weight-500'>{currentTrip.tripCode}</span>
              </ToolTip>
            </div>
          )}
        </section>
      </React.Fragment>
    )
  }
}

export default TripActivityLog



// WEBPACK FOOTER //
// ./src/components/trips/trip-detail/TripActivityLog.tsx